import Accordion from 'LuxKit/Accordion'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'

export default function AdminGettingStarted() {
  return (
    <Group direction="vertical" gap={8}>
      <Heading variant="heading4">Getting started</Heading>
      <Accordion size="large" heading="Getting started for Admins">
        <BodyText variant="large" weight="bold">Getting Started</BodyText>
        <BodyText variant="large">
          Follow the prompts in your Admin Dashboard to complete your onboarding process, including setting up your travellers, policies, processes and preferences.
        </BodyText>
        <hr />
        <BodyText variant="large" weight="bold">Invite travellers</BodyText>
        <BodyText variant="large">
          There are a couple of ways to add new travellers to your Business Traveller account.
        </BodyText>
        <br />
        <BodyText variant="large" weight="bold">In bulk</BodyText>
        <BodyText variant="large">
          Contact your Account manager and send them your list of travellers.
        </BodyText>
        <br />
        <BodyText variant="large" weight="bold">Individually</BodyText>
        <BodyText variant="large">
          Go to the Traveller tab in your Admin Dashboard.
        </BodyText>
        <BodyText variant="large">
          Invite travellers to Business Traveller and define their role.
        </BodyText>
        <hr />
        <BodyText variant="large" weight="bold">Add a travel policy</BodyText>
        <BodyText variant="large">
          You can manage your company's travel expenditure by creating and setting travel policies for all travellers to adhere to.
        </BodyText>
        <ol>
          <Group direction="vertical" gap={12}>
            <li>
              <BodyText variant="large">
                Go to the <b>Policy</b> tab in your Admin Dashboard
              </BodyText>
            </li>
            <li>
              <BodyText variant="large">
                Add a <b>Hotel</b> and / or <b>Flight</b> policy
              </BodyText>
            </li>
            <li>
              <BodyText variant="large">
                Select a <b>Gamification</b> percentage to reward your travellers for spending under budget.
              </BodyText>
            </li>
          </Group>
        </ol>
        <BodyText variant="large">
          If your company frequently travels to specific destinations, you can streamline expense management by setting predefined budgets.
        </BodyText>
        <BodyText variant="large">
          Accommodation budget is calculated per night. Flight budgets are based off a one-way flight, and are doubled for a return flight.
        </BodyText>
        <hr />
        <BodyText variant="large" weight="bold">Set up an approval process</BodyText>
        <BodyText variant="large">
          You can manage your company's travel expenditure by creating and assigning approval processes for all or specific travellers. If you do not wish for your company's trips to be approved by someone, you can skip this step.
        </BodyText>
        <ol>
          <Group direction="vertical" gap={12}>
            <li>
              <BodyText variant="large">
                Go to the <b>Approval Process</b> tab in your Admin Dashboard
              </BodyText>
            </li>
            <li>
              <BodyText variant="large">
                Add an approval process by specify the conditions under which the approval process is activated.
              </BodyText>
            </li>
            <li>
              <BodyText variant="large">
                Determine which travellers will be subject to this approval process.
              </BodyText>
            </li>
            <li>
              <BodyText variant="large">
                Define the individuals responsible for approving trips within this process.
              </BodyText>
            </li>
          </Group>
        </ol>
        <hr />
        <BodyText variant="large" weight="bold">Link or join a Business Frequent Flyer program</BodyText>
        <BodyText variant="large">
          You can link or join a Business Frequent Flyer program in order to access exclusive corporate flight fares.
        </BodyText>
        <br />
        <BodyText variant="large" weight="bold">Already part of a Frequent Flyer Program?</BodyText>
        <ol>
          <Group direction="vertical" gap={12}>
            <li>
              <BodyText variant="large">
                Go to the <b>Account</b> tab in your Admin Dashboard
              </BodyText>
            </li>
            <li>
              <BodyText variant="large">
                Find <b>Business Frequent Flyer</b> and select your program.
              </BodyText>
            </li>
            <li>
              <BodyText variant="large">
                Your account manager will verify and link your program to Business Traveller
              </BodyText>
            </li>
          </Group>
        </ol>
        <BodyText variant="large" weight="bold">Not a part of a Frequent Flyer Program?</BodyText>
        <ol>
          <Group direction="vertical" gap={12}>
            <li>
              <BodyText variant="large">
                Go to the <b>Account</b> tab in your Admin Dashboard
              </BodyText>
            </li>
            <li>
              <BodyText variant="large">
                Find <b>Business Frequent Flyer</b> and select which program you are interested in.
              </BodyText>
            </li>
            <li>
              <BodyText variant="large">
                Your account manager will reach out and guide you through the application process.
              </BodyText>
            </li>
          </Group>
        </ol>
      </Accordion>
    </Group>
  )
}
